export const LOGO_HEADER = "https://customer-assets-jai6qajn.emergentagent.net/job_33d6188f-e8d1-44b1-a696-bd8cb25d410f/artifacts/vr7p3rfb_AzioniSolidali-Colori.png";
export const LOGO_FOOTER = "https://customer-assets-jai6qajn.emergentagent.net/job_33d6188f-e8d1-44b1-a696-bd8cb25d410f/artifacts/nngmlkio_logo-cantieri-educativa-cooperativa-sociale-LUNGO.png";
export const ADDRESS_LINE = "Polo Sociale e Centro Educativo - via Castellana 22 \u2013 31050 Vedelago (TV)";
export const APP_NAME = "INSIEME RAS";
export const APP_SUBTITLE = "Sistema Operativo Intelligente della Rete Azioni Solidali";

export const CASE_STATUS = {
  "Nuova": { bg: "#EAF3FF", text: "#0B3A75", border: "#BBD7FF" },
  "Assegnata": { bg: "#FFF1E6", text: "#7A3E00", border: "#FFD2A8" },
  "Presa in carico": { bg: "#EAF8F0", text: "#0B5D3B", border: "#BFEAD2" },
  "Utente contattato": { bg: "#EAF3FF", text: "#0B3A75", border: "#BBD7FF" },
  "Appuntamento fissato": { bg: "#EAF3FF", text: "#0B3A75", border: "#BBD7FF" },
  "In lavorazione": { bg: "#FFF7ED", text: "#7A3E00", border: "#FED7AA" },
  "Sospesa": { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
  "Conclusa": { bg: "#EAF8F0", text: "#0B5D3B", border: "#BFEAD2" },
  "Non accolta": { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
  "Annullata": { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
  "Archiviata": { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
};

export const PRIORITY = {
  "Bassa": { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
  "Normale": { bg: "#EAF3FF", text: "#0B3A75", border: "#BBD7FF" },
  "Alta": { bg: "#FFF1E6", text: "#7A3E00", border: "#FFD2A8" },
  "Urgente": { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
};

export const TASK_STATUS = {
  "Da fare": { bg: "#EAF3FF", text: "#0B3A75", border: "#BBD7FF" },
  "In corso": { bg: "#FFF7ED", text: "#7A3E00", border: "#FED7AA" },
  "In attesa": { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
  "Completata": { bg: "#EAF8F0", text: "#0B5D3B", border: "#BFEAD2" },
  "Annullata": { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
  "Scaduta": { bg: "#FEE4E2", text: "#7A271A", border: "#FECDCA" },
};

export const NAV_ITEMS = [
  { to: "/app", label: "Dashboard", icon: "LayoutDashboard", perm: "dashboard.view", end: true },
  { to: "/app/centralino", label: "Modalità Centralino", icon: "Headphones", perm: "interactions.write", highlight: true },
  { to: "/app/persone", label: "Persone", icon: "Users", perm: "persons.read" },
  { to: "/app/organizzazioni", label: "Organizzazioni e partner", icon: "Building2", perm: "orgs.read", adminOnly: true },
  { to: "/app/pratiche", label: "Richieste e pratiche", icon: "FolderKanban", perm: "cases.read" },
  { to: "/app/diario", label: "Diario operativo", icon: "BookOpen", perm: "interactions.read", adminOnly: true },
  { to: "/app/attivita", label: "Attività", icon: "CheckSquare", perm: "tasks.read" },
  { to: "/app/accessi", label: "Gestione accessi", icon: "ScanLine", perm: "accessi.register" },
  { to: "/app/agenda", label: "Agenda", icon: "CalendarDays", perm: "appointments.read" },
  { to: "/app/servizi", label: "Servizi", icon: "HeartHandshake", perm: "services.read" },
  { to: "/app/enti", label: "Enti e strutture", icon: "Landmark", perm: "entities.read", adminOnly: true },
  { to: "/app/documenti", label: "Documenti", icon: "FileText", perm: "documents.read" },
  { to: "/app/report", label: "Report", icon: "BarChart3", perm: "reports.view" },
  { to: "/app/assistente-ai", label: "Assistente AI", icon: "Sparkles", perm: "ai.use" },
  { to: "/app/notifiche", label: "Notifiche", icon: "Bell", perm: "notifications.read" },
  { to: "/app/amministrazione", label: "Amministrazione", icon: "Settings", perm: "admin.users", adminOnly: true },
  { to: "/app/profilo", label: "Profilo personale", icon: "UserCircle", perm: null },
];

export const INTERACTION_TYPES = [
  "Telefonata ricevuta", "Telefonata effettuata", "Email ricevuta", "Email inviata",
  "WhatsApp ricevuto", "WhatsApp inviato", "SMS", "Colloquio", "Appuntamento", "Incontro",
  "Visita", "Riunione", "Richiesta web", "Documento ricevuto", "Documento inviato",
  "Attività eseguita", "Nota interna", "Cambio di stato", "Assegnazione", "Mancata risposta",
  "Rinvio", "Annullamento", "Altro",
];

export const CLASSIFICATIONS = [
  "utente", "paziente/assistito", "socio", "volontario", "corsista", "partecipante eventi",
  "familiare", "donatore", "referente", "professionista", "dipendente", "collaboratore", "partner", "altro",
];

export const CASE_STATUSES = Object.keys(CASE_STATUS);
export const PRIORITIES = Object.keys(PRIORITY);
export const TASK_STATUSES = Object.keys(TASK_STATUS);
